import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091a8555"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reordering flashcards in deck", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_IonItem = _resolveComponent("IonItem")!
  const _component_IonReorder = _resolveComponent("IonReorder")!
  const _component_IonReorderGroup = _resolveComponent("IonReorderGroup")!
  const _component_IonList = _resolveComponent("IonList")!
  const _component_IonButton = _resolveComponent("IonButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, [
      _hoisted_1,
      _createTextVNode(),
      _createVNode(_component_IonIcon, {
        icon: _ctx.arrowBackCircleOutline,
        class: "quick-back",
        onClick: _ctx.dismiss,
        alt: "back"
      }, null, 8, ["icon", "onClick"])
    ]),
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("form", null, [
        _createVNode(_component_IonList, { "radio-group": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_IonReorderGroup, {
              disabled: false,
              onIonItemReorder: _ctx.handleMoveCard
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewableCards, (card) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: card.id
                  }, [
                    _createVNode(_component_IonReorder, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_IonItem, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_IonLabel, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(card.kaska) + " - " + _toDisplayString(card.english), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onIonItemReorder"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_IonButton, {
        class: "reorder-image--return",
        color: "secondary",
        fill: "outline",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonIcon, { icon: _ctx.returnDownBackOutline }, null, 8, ["icon"]),
          _createTextVNode(" Done ")
        ]),
        _: 1
      })
    ])
  ], 64))
}